import React, { useState } from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import CardActions from '@material-ui/core/CardActions';
import Avatar from '@material-ui/core/Avatar';
import IconButton from '@material-ui/core/IconButton';
import CustomIconButton from '../CustomIconButton';
import Typography from '@material-ui/core/Typography';
import Tooltip from '@material-ui/core/Tooltip';
import BasketIcon from '../../icons/BasketIcon';
import FavoritesIcon from '../../icons/FavoritesIcon';
import ModernSystemsIcon from '../../icons/ModernSystemsIcon';
import AppTagChipArray from './AppTagChipArray';
import AppTagChipArrayTop from './AppTagChipArrayTop';
import AppTagChipArrayBottom from './AppTagChipArrayBottom';
import Grid from "@material-ui/core/Grid";
import ArrowSendIcon from '../../icons/ArrowSendIcon';
import translate from '../../other/translate.json';
import icons_bn from '../../other/icons_bn.json';
import Chip from '@material-ui/core/Chip';
import ClampLines from "react-clamp-lines";
import AppCardTagList from './AppCardTagList';
import AppCardAlternativeList from './AppCardAlternativeList';
import FavoriteButton from '../Favorites/FavoriteButton';
import clsx from 'clsx';
import utils from '../../other/utils';
import KloStatus from '../KloSatus';
export default function AppLineCard(props) {
	const classes = useStyles();
	let { isProd, data, readLink, type, basket, notDeleteFromBasketArr, notDeleteFromBasketArrCloud, cart, setAppBasket, checkAll, setCheckAll, setArrayTag, arrayTag, loadingKloStatuses } = props
	const lang = localStorage.getItem('language') || 'Ru';
	let langYE = lang === 'Ru' ? ' тыс.у.е.' : ' K c.u.'
	let langYEM = lang === 'Ru' ? ' тыс.у.е./мес.' : ' K c.u./month'
	const kloStatus = props.data.codeasvul && props.kloStatuses && props.kloStatuses[props.data.codeasvul] ? props.kloStatuses[props.data.codeasvul] : '';
	const kloUser = props.kloUser;
	let inCu = props.userCollection.CatalogCu || props.userCollection.inCu;
	if (inCu === '1' && props.data.Currency === 1) {
		inCu = '0'
	} else if (inCu !== '1' && props.data.Currency === 0) {
		inCu = '1'
	}

	// const setAppBasket_ = (appID) => {
	// 	// setAppBasketA(appID)
	// 	// let r = JSON.parse(localStorage.getItem('cartApp')) || []
	// 	setAppBasket(appID)
	// }
	// const [basketChips, _appBasket] = useState(JSON.parse(localStorage.getItem('cartApp')) || [])

	// const setApp = (prod) => {
	// 	if (isProd === true) { } else {
	// 		setCheckAll(!checkAll)
	// 	}

	// 	if (basketChips.some((element) => element === prod.ID) === true) {
	// 		_appBasket(basketChips.filter(el_ => el_ !== prod.ID))
	// 		let r = JSON.parse(localStorage.getItem('cartApp')) || []
	// 		localStorage.setItem('cartApp', JSON.stringify(r.filter(el_ => el_ !== prod.ID)))
	// 	} else {
	// 		_appBasket(basketChips.concat(prod.ID))
	// 		let r = JSON.parse(localStorage.getItem('cartApp')) || []
	// 		localStorage.setItem('cartApp', JSON.stringify(r.concat(prod.ID)))
	// 	}
	// }

	let tagsName = props.data.tags_q ? props.data.tags_q.split(',').map(el => el.split('#;')[0]).join() : '';

	function disablePriority() {
		if (props.usname !== null) {
			if (props.disablePriorityBtn && props.disablePriorityBtn.includes(props.data.codeasvul)) {
				return (true)
			} else if (props.data.RESEARCHMARKETMAILS) {
				return (props.usname === null ? true : props.data.RESEARCHMARKETMAILS.includes(props.usname.email))
			}
		} else {
			return (true)
		}
	}

	/* ЦЕНА ПО АКЦИИ >>>>> */
	function ActionPriceOne() {
		if (+props.data.paymentonestock) {
			if (+props.data.paymentonestock < +props.data.paymentone) {
				return (
					<Grid item style={{ display: 'inline-flex' }}>
						<CustomTooltip title={lang === 'Ru' ? 'Особые условия лицензирования – см. страницу с описанием Приложения' : "Special license terms – see. Application description page"}>
							<Typography className={classes.pricePrimary}>
								{
									props.data.paymentonestock.toLocaleString('ru-RU', { maximumFractionDigits: 3 })
								}
							</Typography>
						</CustomTooltip>

						{/* <CustomTooltip title={translate.Words[`CurrentRate${lang}`]}>
							<Typography className={classes.pricePrimary} style={{ paddingLeft: 4 }}>
								{langYE}
							</Typography>
						</CustomTooltip> */}
						{renderAppCurrency('elp', false)}
					</Grid>
				)
			}
		}
	}

	function PriceCommentELP() {
		return (
			<span>
				{translate.Words[`Price11${lang}`]}
				/
				<br />
				{translate.Words[`Price12${lang}`]}
			</span>
		)
	}

	function ActionPriceMonthly() {
		if (+props.data.paymentmonthlystock) {
			if (+props.data.paymentmonthlystock < +props.data.paymentmonthly) {
				return (
					<Grid item style={{ display: 'inline-flex' }}>
						<Typography className={classes.pricePrimary}>{props.data.paymentmonthlystock.toLocaleString('ru-RU', { maximumFractionDigits: 3 })}</Typography>

						{/* <CustomTooltip title={translate.Words[`CurrentRate${lang}`]}>
							<Typography className={classes.pricePrimary} style={{ paddingLeft: 4 }}>
								{langYEM}
							</Typography>
						</CustomTooltip> */}
						{renderAppCurrency('lp', false)}

					</Grid>
				)
			}
		}
	}
	/* <<<<< ЦЕНА ПО АКЦИИ */

	const renderFavoritesIcon = (row, isCart, appFavorite, appsInProducts) => {
		let appInFavorite = appFavorite && appFavorite.includes(row.ID);
		let title = appInFavorite ? translate.Words[`RemoveFromFavorite${lang}`] : translate.Words[`AddToFavorite${lang}`];
		let fill = appInFavorite ? '#FFFFFF' : '#BCBBD0';
		let onClick = /*isBasket ?*/ () => { props.saveCollection(row.ID, 'app', 'favorite'); if (isCart && !!props.updateArr) { props.updateArr('favorite', row, 'app'); } };
		let backgroundColor = appInFavorite ? '#EB505E' : undefined;
		if (appsInProducts.includes(row.ID)) {
			fill = '#BCBBD0';
			backgroundColor = undefined;
			title = translate.Words[`AppIsPartOfProducts_${lang}`];
			onClick = () => { }
		}

		return (
			row.dateendsale.length > 2 || row.researchmarket.length > 2 || row.isModernSystems === 1
				?
				null
				:
				<FavoriteButton fill={fill} title={title} onClick={onClick} backgroundColor={backgroundColor} />
		)
	}

	const renderBasketIcons = (row, isBasket, appBasket, appsInProducts) => {
		if (row.researchmarket == "Изучается спрос" || row.researchmarket == "Demand under research") {
			return (
				<HtmlTooltip
					interactive
					title={
						props.usname === null
							?
							lang === 'Ru'
								?
								<Grid item style={{ fontSize: '14px !important' }}><a href={'https://catalog.cft.ru/login?linkTo=' + window.location.href}>Авторизуйтесь</a>, чтобы повысить приоритет </Grid>
								:
								<Grid item style={{ fontSize: '14px !important' }}>Please <a href={'https://catalog.cft.ru/login?linkTo=' + window.location.href}>Log in</a> to raise priority </Grid>
							:
							row.RESEARCHMARKETMAILS && row.RESEARCHMARKETMAILS.includes(props.usname.email)
								?
								<Grid item style={{ fontSize: '14px !important' }}>{translate.Words[`YourVoteHasBeenRegistered${lang}`]} </Grid>
								:
								<Grid item style={{ fontSize: '14px !important' }}>{translate.Words[`ClickToIncreasePriority${lang}`]} </Grid>
					}
				>
					<Grid item>
						<CustomIconButton
							aria-label="share"
							className={classes.icon}
							disabled={disablePriority(row.codeasvul, row.RESEARCHMARKETMAILS)}
							func={() => props.upPriority(row.RESEARCHMARKETMAILS, row.codeasvul)}
							bgcolor={'#F6F6FB'}
							hbgcolor={'#5D75F8'}
							shadow={'none'}
							hshadow={'0px 6px 24px rgba(128, 148, 255, 0.4)'}
							icon={props.usname === null ? 1 : disablePriority(row.codeasvul, row.RESEARCHMARKETMAILS) ? 2 : 1}
							discolor={disablePriority(row.codeasvul, row.RESEARCHMARKETMAILS) ? '#EEEEF5' : null}
						/>
					</Grid>
				</HtmlTooltip>
			)
		} else if (row.isModernSystems === 1) {
			return (
				<IconButton onClick={() => window.open(`https://${row.ModernSystemLink}`)} color={'primary'} aria-label="share" className={classes.icon} style={{ backgroundColor: '#7D62BA' }}>
					<ModernSystemsIcon fill={'#FFFFFF'} />
				</IconButton>
			)
		} else {
			let appInBasket = appBasket && appBasket.includes(row.ID);
			let title = appInBasket ? translate.Words[`RemoveFromBasket${lang}`] : translate.Words[`AddTobasket${lang}`];

			//let onClick = isBasket ? () => {removeApp(row)} : () => {setAppBasket(row)} ;
			let backgroundColor = appInBasket ? '#EB505E' : undefined;
			let fill = appInBasket ? '#FFFFFF' : '#BCBBD0'
			let onClick = /*isBasket ?*/ () => { props.saveCollection(row.ID, 'app', 'cart'); if (!!props.updateArr) { props.updateArr('cart', row, 'app'); } };

			if (appsInProducts.includes(row.ID)) {
				fill = '#BCBBD0';
				backgroundColor = undefined;
				title = translate.Words[`AppIsPartOfProducts_${lang}`];
				onClick = () => { }
			}
			return (
				row.dateendsale.length > 2 || row.researchmarket.length > 2
					?
					null
					:
					<CustomTooltip placement="bottom" title={title}>
						<IconButton color={'primary'} aria-label="share" onClick={onClick} className={classes.icon} style={{ backgroundColor }}>
							<BasketIcon fill={fill} />
						</IconButton>
					</CustomTooltip>
			)
		}
	}


	function AppCardActions(loadingKloStatuses) {
		return (
			<CardActions disableSpacing className={classes.actions}>
				<Grid xs={12} container
					direction="row"
					justify="space-between"
					alignItems="center"
					style={{ paddingLeft: 84 }}
				>
					<Grid item container direction='row' xs={8} style={{ marginLeft: -8 }}>
						<Grid item>
							{
								utils.hasProperty(props.data.tags_q)
									?
									<AppCardTagList
										tagsQ={props.data.tags_q}
										setArrayTag={setArrayTag}
										arrayTag={arrayTag}
									/>
									:
									null
							}
						</Grid>

						<Grid item style={{ marginLeft: 8 }}>
							{
								props.alternatives?.filter(obj => obj.DependID === props.data.ID)
									?
									<AppCardAlternativeList
										analogs={[...new Set(props.alternatives?.filter(obj => obj.DependID === props.data.ID).map(alt => alt.Alternatives).join().split(','))].join()}
										codeasvul={props.data.codeasvul}
										inCu={inCu}
									/>
									:
									null
							}
						</Grid>
					</Grid>

					{props.data.dateendsale.length > 2 || props.data.researchmarket.length > 2
						?
						null
						:
						<Grid item xs={4} style={{ display: 'flex', justifyContent: 'flex-end' }} >
							{
								props.data.isModernSystems === 1
									?
									<Grid item container direction="row" alignItems="center" justify="flex-end" >
										<Grid item style={{ maxWidth: '80%', marginRight: 4 }}>
											<Typography style={{ color: '#7D62BA', fontSize: '13px', lineHeight: '16px' }}>С сайта “Современные Системы”</Typography>
										</Grid>

										<IconButton color={'primary'} aria-label="share" className={classes.icon} style={{ backgroundColor: '#7D62BA' }}>
											<ModernSystemsIcon fill={'#FFFFFF'} />
										</IconButton>
									</Grid>
									:
									<Grid item container direction="row" alignItems="center" justify="space-between"   >
										<Grid item style={{ /*width: 'calc(33.3333% - 72px)'*/  marginRight: cart ? 4 : 24 }}>
											<KloStatus kloUser={kloUser} kloStatus={props.kloStatuses[props.data.codeasvul]} codeasvul={props.data.codeasvul} loadingKloStatuses={loadingKloStatuses} />
										</Grid>
										<Grid item>
											{renderFavoritesIcon(props.data, cart, props.userCollection.appFavorite, props.userCollection.appFavoriteInProduct)}
											{renderBasketIcons(props.data, cart, props.userCollection.appBasket, props.userCollection.appCartInProduct)}
										</Grid>

									</Grid>
							}
						</Grid>
					}
				</Grid>
			</CardActions>
		)

	}

	const renderAppCurrency = (type, condition) => (
		inCu === '1'
			?
			<CustomTooltip title={<span>
				{translate.Words[`CurrentRate_${lang}`]}
				{/* <br />{translate.Words[`NextRate_${lang}`]} */}
			</span>}>
				<Typography
					className={clsx(classes.pricePrimary, {
						[classes.priceSecondary]: condition
					})}
					style={{ paddingLeft: 4 }}
				>
					{utils.getPriceItem(inCu, lang, type)}
				</Typography>
			</CustomTooltip>
			:
			<Typography
				className={clsx(classes.pricePrimary, {
					[classes.priceSecondary]: condition
				})}
				style={{ paddingLeft: 4 }}
			>
				{utils.getPriceItem(inCu, lang, type)}
			</Typography>
	)



	const renderPrice = () => {
		if (props.data.isHidePrice === 1) {
			return (
				<Grid item container direction="row" className={classes.priceContainer} style={{ padding: 0, justifyContent: 'space-between' }}>
					<Grid item style={{ display: 'grid', height: 36, minWidth: '30%' }}> {lang === 'Ru' ? 'По запросу' : 'On request'} </Grid>
				</Grid>
			)
		} else {
			return (
				<Grid item container direction="row" className={classes.priceContainer} style={{ marginTop: 8, padding: 0, justifyContent: 'space-between' }}>

					<Grid item style={{ display: 'grid' }}>
						{ActionPriceOne()}

						<Grid item style={{ display: 'inline-flex' }}>
							<CustomTooltip title={PriceCommentELP()}>
								<Typography
									className={clsx(classes.pricePrimary, {
										[classes.priceSecondary]: +props.data.paymentonestock > 0 && +props.data.paymentonestock < +props.data.paymentone
									})}
								>
									{
										utils.getCurrentPrice(props.data.paymentone, lang)
									}
								</Typography>
							</CustomTooltip>

							{
								typeof props.data.paymentone === 'number' && props.data.paymentone > 0
									?
									renderAppCurrency('elp', +props.data.paymentonestock > 0 && +props.data.paymentonestock < +props.data.paymentone)
									:
									null
							}

							<HtmlTooltip
								interactive
								title={
									props.data.paymentcommentone !== '*' && props.data.paymentcommentone !== '**'
										?
										<Grid item dangerouslySetInnerHTML={{ __html: props.data.paymentcommentone }} style={{ fontSize: '14px !important' }}></Grid>
										:
										<Grid item dangerouslySetInnerHTML={{ __html: props.data.Fullpaymentcomment }} style={{ fontSize: '14px !important' }}></Grid>
								}
							>
								{
									props.data.paymentcommentone?.length > 4
										?
										<Typography className={classes.pricePrimary}>*</Typography>
										:
										<Typography className={classes.pricePrimary}>{props.data.paymentcommentone}</Typography>
								}
							</HtmlTooltip>
						</Grid>
					</Grid>

					<Grid item style={{ display: 'grid' }}>
						{ActionPriceMonthly()}
						<Grid item style={{ display: 'inline-flex' }}>
							<CustomTooltip title={lang === 'Ru' ? 'Ежемесячный лицензионный платеж / Периодическая лицензия' :
								"Monthly license payment / Periodic license"}>
								<Typography className={classes.pricePrimary}>
									{
										utils.getCurrentPrice(props.data.paymentmonthly, lang)
									}
								</Typography>
							</CustomTooltip>

							{typeof props.data.paymentmonthly === 'number' && props.data.paymentmonthly > 0
								?
								renderAppCurrency('lp', +props.data.paymentonestock > 0 && +props.data.paymentmonthlystock < +props.data.paymentmonthly)
								:
								null
							}

							{props.data.Title_catalog === "ЦФТ-Ритейл банк" && props.data.Fullpaymentcomment
								?
								// <CustomTooltip title={props.data.Fullpaymentcomment.substr(0, 33) === 'Примечание к ежемесячному платежу' ? props.data.Fullpaymentcomment.replace(/(\<(\/?[^>]+)>)/g, '').replace('Примечание к ежемесячному платежу: ', 'Особые условия лицензирования: ') : ''}>
								<HtmlTooltip
									interactive
									title={
										props.data.paymentcommentmonthly?.length > 5
											?
											<Grid item dangerouslySetInnerHTML={{ __html: props.data.paymentcommentmonthly }} style={{ fontSize: '14px !important' }}>
											</Grid>
											:
											props.data.paymentcommentmonthly !== '*'
												?
												''
												:
												<Grid item dangerouslySetInnerHTML={{ __html: props.data.Fullpaymentcomment }} style={{ fontSize: '14px !important' }}>
												</Grid>
									}
								>
									<Typography component='span' className={classes.pricePrimary} style={{ cursor: 'default', maxWidth: 5 }}>{props.data.paymentcommentmonthly?.length > 5 ? '*' : props.data.paymentcommentmonthly}</Typography>
								</HtmlTooltip>
								// </CustomTooltip>
								:
								<HtmlTooltip
									interactive
									title={
										props.data.paymentcommentmonthly?.length > 5
											?
											<Grid item dangerouslySetInnerHTML={{ __html: props.data.paymentcommentmonthly }} style={{ fontSize: '14px !important' }}>
											</Grid>
											:
											props.data.paymentcommentmonthly !== '*'
												?
												''
												:
												<Grid item dangerouslySetInnerHTML={{ __html: props.data.Fullpaymentcomment }} style={{ fontSize: '14px !important' }}>
												</Grid>
									}
								>
									<Typography component='span' className={classes.pricePrimary} style={{ cursor: 'default', maxWidth: 5 }}>{props.data.paymentcommentmonthly?.length > 5 ? '*' : props.data.paymentcommentmonthly}</Typography>
								</HtmlTooltip>
							}
						</Grid>
					</Grid>
				</Grid>
			)
		}
	}

	function renderCard() {
		return (
			<Card className={classes.rootWide}>
				<Grid
					container
					direction="column"
					alignItems="stretch"
					style={{ justifyContent: "space-between", minHeight: 170 }}
				>
					<Grid item container>
						<Grid item container className={classes.cntrCardHeader}>
							<Grid item style={{ width: '50%', paddingLeft: 88 }}>
								{
									props.data.isModernSystems === 1
										?
										<Grid item style={{ height: 21 }}></Grid>
										:
										<Typography component='span' style={{ fontSize: '14px' }}>{props.data.Title_catalog}</Typography>
								}
							</Grid>
							{basket
								?
								<AppTagChipArrayTop
									dataStartSale={props.data.promo}
									variant={1}
									isStandant={props.data.standartpackage}
									isResearchMarket={props.data.researchmarket}
									isCloudApp={props.data.isCloudApp}
									promo={props.data.promo}
									dataEndSale={props.data.dateendsale}
									announcement={props.data.announcement}
									width={'50%'}
									isModernSystems={props.data.isModernSystems}
									position='top'
									event={props.data.StockLink ? props.data.StockLink : null}
									isNew={props.data.isNew}
								/>
								:
								<li key={`${data.key}__topChipData`} className={classes.li}>
									<Chip
										style={{ backgroundColor: data.bgcolor }}
										label={data.Progress}
										className={classes.chip}
									/>
								</li>
							}
						</Grid>

						<Grid item container alignItems="flex-start" className={classes.cntrCardBody}>
							<Grid container xs={4} alignItems="flex-start" className={classes.cntrCardBodyBlock}>
								<StyledCardHeader
									className={classes.header}
									avatar={
										props.data.isModernSystems === 1
											?
											<Avatar
												aria-label="recipe"
												className={classes.avatar}
												style={{ backgroundColor: '#F0ECF9' }}
												src={icons_bn[`ModernSystems`]}
											></Avatar>
											:
											<Avatar aria-label="recipe" className={classes.avatar}
												style={{ backgroundColor: data.color && data.color.length > 5 ? `#${data.color}` : '#E45670' }}
												src={icons_bn[`${props.data.icon_id_bn}`]}
											>
											</Avatar>
									}

									title={
										<React.Fragment>
											<Grid container direction="row" justify="flex-start" alignItems="center" spacing={3} style={{ marginTop: 0, marginBottom: 12 }}>
												{props.data.researchmarket !== "" ? null : <AppTagChipArray key1={data.codeasvul} key2={data.version} key3={data.datestartsale} position='middle' />}
											</Grid>

											{
												(window.location.pathname.slice(1, 5) == "appl" || window.location.pathname.slice(1, 5) == "sear" || window.location.pathname.slice(1, 5) == "cart")
													?
													props.data.isModernSystems === 1
														?
														<Typography style={{ fontSize: '12px', lineHeight: '14px', fontWeight: '500' }}>
															{props.data[`ModernSystemBN`]}
														</Typography>
														:
														<a href={`/${props.type}/${props.data['url_catalog']}/applist?filt=false&direction=${props.data['businessdirectionid']}`} className={classes.LinkType01} style={{ marginBottom: 8 }}>
															{props.data[`bn_title`]}
														</a>
													:
													<Typography style={{ fontSize: '12px', lineHeight: '14px', fontWeight: '500', marginBottom: 8 }}>
														{props.data[`bn_title`]}
													</Typography>

											}
										</React.Fragment>
									}

									subheader={
										(props.data.isModernSystems !== 1 && (window.location.pathname.slice(1, 5) == "appl" || window.location.pathname.slice(1, 5) == "sear" || window.location.pathname.slice(1, 5) == "cart"))
											?
											<a href={`/${props.type}/${props.data['url_catalog']}/applist?filt=false&direction=&section=${props.data['sectionid']}`} className={classes.LinkType02} style={{ marginTop: 4 }}>
												<ClampLines
													id={'subheader_' + props.data[`ID`]}
													text={props.data[`sn_title`] !== null ? props.data[`sn_title`] : ''}
													lines={2}
													buttons={false}
													ellipsis="..."
													className={classes.LinkType02}
													innerElement="p"
												/>
											</a>
											:
											props.data.isModernSystems === 1
												?
												<Typography className={classes.subheader} style={{ marginTop: 4 }}>
													{props.data[`ModernSystemProduct`]}
												</Typography>
												:
												<Typography className={classes.subheader}>
													{props.data[`sn_title`]}
												</Typography>
									}
								/>
							</Grid>

							<Grid container xs={8}>
								<CardContent className={classes.content}>
									{basket
										?
										<Grid container xs={12}>
											{readLink === false
												?
												<Grid container xs={6} direction="column" justify="flex-start" alignItems="flex-start">
													{
														props.data.isModernSystems === 1
															?
															<React.Fragment>
																<Typography variant="body2" color="textSecondary" component="p" className={classes.contentBody}>
																	{props.data.title}
																</Typography>

																<Typography variant="body2" color="textSecondary" component="p" className={classes.contentSubbody}>
																	<ClampLines
																		text={(props.data && props.data.briefdescription) || ''}
																		lines={4}
																		buttons={false}
																		ellipsis="..."
																	/>
																	{/* {props.data.briefdescription} */}
																</Typography>
															</React.Fragment>
															:
															<a href={`/${type}/card/${props.data.codeasvul}`} style={{ textDecoration: 'none', maxWidth: '100%' }} rel="noopener noreferrer" target="_blank">
																<Typography variant="body2" color="textSecondary" component="p" className={classes.contentBody}>
																	{props.data.title}
																</Typography>

																<Typography variant="body2" color="textSecondary" component="p" className={classes.contentSubbody}>
																	<ClampLines
																		text={(props.data && props.data.briefdescription) || ''}
																		lines={4}
																		buttons={false}
																		ellipsis="..."
																	/>
																	{/* {props.data.briefdescription} */}
																</Typography>
															</a>
													}
												</Grid>
												:
												<Grid container xs={6} direction="column" justify="flex-start" alignItems="flex-start">
													<Typography variant="body2" color="textSecondary" component="p" className={classes.contentBody}>
														{props.data.title}
													</Typography>
													{
														Math.sign(147 - (h + h2)) === -1
															?
															<CustomTooltip title={props.data.briefdescription}>
																<Typography variant="body2" color="textSecondary" component="p" className={classes.contentSubbody}>
																	<ClampLines
																		text={(props.data && props.data.briefdescription) || ''}
																		lines={4}
																		buttons={false}
																		ellipsis="..."
																	/>
																	{/* {props.data.briefdescription} */}
																</Typography>
															</CustomTooltip>
															:
															<Typography variant="body2" color="textSecondary" component="p" className={classes.contentSubbody}>
																<ClampLines
																	text={(props.data && props.data.briefdescription) || ''}
																	lines={4}
																	buttons={false}
																	ellipsis="..."
																/>
																{/* {props.data.briefdescription} */}
															</Typography>
													}
												</Grid>
											}

											<Grid container direction="column" style={{ justifyContent: "flex-start", alignItems: "stretch", maxWidth: 283, marginLeft: 25 }}>
												{/* <CustomTooltip title={props.data.paymentcomment !== '*' ? '' : lang === 'Ru' ? 'Особые условия лицензирования' :
										"Special licensing conditions"}> */}
												<HtmlTooltip
													interactive
													title={
														props.data?.paymentcomment?.length > 5
															?
															<Grid item dangerouslySetInnerHTML={{ __html: props.data.paymentcomment }} style={{ fontSize: '14px !important' }}>
															</Grid>
															:
															props.data.paymentcomment !== '*'
																?
																''
																:
																<Grid item dangerouslySetInnerHTML={{ __html: props.data.Fullpaymentcomment }} style={{ fontSize: '14px !important' }}>
																</Grid>
													}
												>
													{props.data.researchmarket /* Предполагаемая цена / Цена на карточках */
														?
														<Typography className={classes.subheader}>
															{translate.Words[`PlannedPrice${lang}`]}  {props.data.paymentcomment?.length > 5 ? '*' : props.data.paymentcomment}
														</Typography>
														:
														// props.data.Title_catalog === "ЦФТ-Ритейл банк" && props.data.Fullpaymentcomment
														// 	?
														// 	<CustomTooltip title={props.data.Fullpaymentcomment.substr(0, 17) === 'Примечание к цене' ? props.data.Fullpaymentcomment.replace(/(\<(\/?[^>]+)>)/g, '').replace('Примечание к цене: ', 'Особые условия лицензирования: ') : ''}>
														// 		<Typography className={classes.subheader}>
														// 			{translate.Words[`Price${lang}`]}{props.data.paymentcomment}
														// 		</Typography>
														// 	</CustomTooltip>
														// 	:
														<Typography className={classes.subheader}>
															{translate.Words[`Price${lang}`]}{props.data.paymentcomment?.length > 5 ? '*' : props.data.paymentcomment}
														</Typography>
													}
												</HtmlTooltip>
												{/* </CustomTooltip> */}

												{/* ЦЕНА ПО АКЦИИ >>>>> */}
												{/* <Grid item container direction="row" className={classes.priceContainer} style={{ padding: 0, justifyContent: 'space-between' }}>
										<Grid item style={{ display: 'inline-flex' }}>
											{ActionPriceOne()}
										</Grid>

										<Grid item style={{ display: 'inline-flex' }}>
											{ActionPriceMonthly()}
										</Grid>
									</Grid> */}
												{/* <<<<< ЦЕНА ПО АКЦИИ */}

												{renderPrice()}
											</Grid>
										</Grid>
										:
										<>
											{/*TODO: ARH подтюнить */}
											{data.Progress2}
											{(props.data && props.data.briefdescription) || ''}
										</>
									}
								</CardContent>
							</Grid>
						</Grid>
					</Grid>

					<Grid item container className={classes.cntrCardFooter}>
						{AppCardActions(loadingKloStatuses)}
					</Grid >
				</Grid >
			</Card >
		)
	}

	let h = (Math.floor(props.data.title.length / 25) * 18) + 18
	let h2 = (Math.floor(props.data.briefdescription.length / 25) * 18)

	return (
		props.data.isModernSystems === 1
			?
			<a href={`https://${props.data.ModernSystemLink}`} style={{ textDecoration: 'none', width: '100%' }} rel="noopener noreferrer" target="_blank">
				{renderCard()}
			</a>
			:
			renderCard()
	);
}

const CustomTooltip = withStyles((theme) => ({
	tooltip: {
		backgroundColor: 'rgba(60, 60, 86, 0.8)',
		color: '#FFFFFF',
		boxShadow: 'none',
		padding: 12,
		borderRadius: 8,
		fontWeight: 'normal',
		fontSize: '12px',
		lineHeight: '14px',
	},
}))(Tooltip);

const HtmlTooltip = withStyles((theme) => ({
	tooltip: {
		backgroundColor: 'rgba(60, 60, 86, 0.87)',
		color: 'rgba(255, 255, 255, 0.87)',
		maxWidth: 500,
		fontSize: theme.typography.pxToRem(12),
		// border: '1px solid #dadde9',
		borderRadius: '8px',
		fontFamily: 'Cera CY',
		fontStyle: 'normal',
		fontWeight: 400,
		padding: 12,
		// paddingBottom: 0,
		opacity: 0.5,

		'& a': {
			color: 'rgba(255, 255, 255, 0.87)',
		}
	},
}))(Tooltip);

const useStyles = makeStyles((theme) => ({
	rootWide: {
		// minHeight: 218,
		marginBottom: 12,
		boxShadow: '4px 4px 10px rgba(164, 163, 186, 0.2)',
		borderRadius: theme.spacing(2),
		padding: "24px 24px 30px",
		// paddingRight: 0,
		// paddingBottom: 24,
		// paddingLeft: 0,
		// padding: theme.spacing(3),
		width: '100%',

		'&:hover': {
			boxShadow: '4px 4px 20px rgba(164, 163, 186, 0.7)',
		}
	},

	avatar: {
		// backgroundColor: iconColor,
		height: 62,
		width: 62,
		borderRadius: 24,
		padding: 15,
		marginRight: 10
	},

	icon: {
		marginLeft: 8,
		backgroundColor: '#F6F6FB',
		width: 48,
		height: 48,
		'&:hover': {
			backgroundColor: '#F6F6FB',
		},
		'&:first-child': {
			marginLeft: 'auto',
		}
	},

	content: {
		// height: 289,
		// overflow: 'hidden',
		padding: 0,
		width: '100%',
		'&:last-child': {
			paddingBottom: 12
		}
		// marginTop: 16
	},

	contentBody: {
		fontSize: '14px',
		fontWeight: '500',
		lineHeight: '18px',
		color: '#000'
	},

	contentSubbody: {
		marginTop: theme.spacing(1),
		fontSize: '13px',
		fontWeight: '400',
		lineHeight: '16px',
		color: '#8987A2'
	},

	header: {
		padding: 0,
		width: '100%',
		title: {
			fontSize: 22
		}
	},

	subheader: {
		fontSize: '12px',
		lineHeight: '14px',
		fontWeight: 400,
		color: '#8987A2'
	},

	actions: {
		padding: '0',
		paddingTop: '7',
		width: '100%',
		// position: 'absolute',
		// bottom: 16,
		// right: 24
	},

	pricePrimary: {
		fontSize: '14px',
		fontWeight: 500,
		lineHeight: '18px',
		color: '#000'
	},

	priceSecondary: {
		fontSize: '14px',
		fontWeight: 500,
		lineHeight: '18px',
		color: '#8987A2',
		textDecoration: 'line-through'
	},

	cntrCardHeader: {
		// padding: '0 24px 0 24px',
		minHeight: 32,
		marginBottom: 4,
	},

	cntrCardBody: {},

	cntrCardBodyBlock: {
		// padding: '0 24px'
	},

	cntrCardFooter: {
		// padding: '0 24px 0 24px'
	},

	LinkType01: {
		fontSize: '12px',
		lineHeight: '14px',
		fontWeight: '500',
		color: "#000000",
		textDecoration: "none",

		'&:hover': {
			textDecoration: 'none',
			borderBottom: '1px solid #000000',
		}
	},

	LinkType02: {
		fontSize: '12px',
		lineHeight: '14px',
		fontWeight: 400,
		color: '#8987A2',
		textDecoration: "none",

		"& > p": {
			fontSize: '12px',
			lineHeight: '14px',
			fontWeight: 400,
			color: '#8987A2',
			textDecoration: "none",
			margin: 0,

			'&:hover': {
				textDecoration: 'underline',
			}
		}
	},
}));

const StyledCardHeader = withStyles({
	root: {
		alignItems: 'flex-start',
		maxWidth: 304,
	},

	title: {
		lineHeight: "14px",
		marginBottom: 8,
	},

	subheader: {
		lineHeight: "14px",
		marginTop: 4,
	}
})(CardHeader);